import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-flex align-center" };
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useDisplay } from 'vuetify';
import { useToastStore } from '@/stores/toast.store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppSnackbar',
    setup(__props) {
        const toast = useToastStore();
        const { state } = storeToRefs(toast);
        const { smAndDown } = useDisplay();
        const location = computed(() => (smAndDown.value ? 'bottom' : 'top right'));
        const iconByType = {
            success: 'mdi-check-circle',
            error: 'mdi-alert-circle',
            warning: 'mdi-alert',
            info: 'mdi-information',
        };
        const icon = computed(() => iconByType[state.value.type] ?? 'mdi-information');
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createBlock(_component_v_snackbar, {
                modelValue: _unref(state).visible,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(state).visible) = $event)),
                color: _unref(state).type,
                location: location.value,
                timeout: 4000,
                rounded: "lg"
            }, {
                actions: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(toast).hide()))
                    }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("Đóng", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    })
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(icon.value), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createElementVNode("span", null, _toDisplayString(_unref(state).message), 1 /* TEXT */)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "color", "location"]));
        };
    }
});
